var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDocumentTermLoan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 14.1693V15.8359C13.3337 16.7564 12.5875 17.5026 11.667 17.5026H5.83366C4.91318 17.5026 4.16699 16.7564 4.16699 15.8359V7.5026C4.16699 6.58213 4.91318 5.83594 5.83366 5.83594H7.50033",
    stroke: "#00B3B5",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5V5.83333C12.5 6.29357 12.8731 6.66667 13.3333 6.66667H16.6667",
    stroke: "#00B3B5",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14.1667H9.16667C8.24619 14.1667 7.5 13.4205 7.5 12.5V4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H12.5L16.6667 6.66667V12.5C16.6667 13.4205 15.9205 14.1667 15 14.1667Z",
    stroke: "#00B3B5",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDocumentTermLoan);
export default __webpack_public_path__ + "static/media/active-document-term-loan.2f1682e1df5ab991cf03939e5897bc5e.svg";
export { ForwardRef as ReactComponent };